import { useState } from 'react'
import { LinkComponent } from '../../../components/UI/LinkComponent/LinkComponent'
import { MAJCAKE_ACADEMY_URL } from '../../../const/consts'
// CRA's ESLint resolver does not understand SCSS modules, while webpack does.
// eslint-disable-next-line import/no-unresolved
import styles from './MigrationNotice.module.scss'

export const MigrationNotice = (): JSX.Element | null => {
  const [isVisible, setIsVisible] = useState(true)

  if (!isVisible) return null

  return (
    <aside
      className={styles.Notice}
      aria-label='Informacja o migracji do Akademii MajCake'
    >
      <div className={styles.Content}>
        <div className={styles.Message}>
          <h2 className={styles.Title}>
            <span aria-hidden='true'>🍰</span> Słodka Szkoła przenosi się do
            Akademii MajCake
          </h2>
          <p className={styles.Description}>
            Do końca września wszystkie kursy i materiały zostaną przeniesione
            do Akademii MajCake. Wszystkie nowe treści będą od teraz publikowane
            już tylko w Akademii MajCake.
          </p>
        </div>
        <LinkComponent
          className={styles.AcademyLink}
          href={MAJCAKE_ACADEMY_URL}
        >
          Przejdź do Akademii MajCake
        </LinkComponent>
        <button
          className={styles.CloseButton}
          type='button'
          aria-label='Zamknij informację o migracji'
          onClick={() => setIsVisible(false)}
        >
          ×
        </button>
      </div>
    </aside>
  )
}
